import { render, staticRenderFns } from "./ComponentEducationNavbar.vue?vue&type=template&id=5b5aab17&scoped=true&"
import script from "./ComponentEducationNavbar.vue?vue&type=script&lang=js&"
export * from "./ComponentEducationNavbar.vue?vue&type=script&lang=js&"
import style0 from "./ComponentEducationNavbar.vue?vue&type=style&index=0&id=5b5aab17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5aab17",
  null
  
)

export default component.exports